export default "__VITE_ASSET__BalSg5EF__"